import { render, staticRenderFns } from "./moveRobot.vue?vue&type=template&id=b930e41a"
import script from "./moveRobot.vue?vue&type=script&lang=js"
export * from "./moveRobot.vue?vue&type=script&lang=js"
import style0 from "./moveRobot.vue?vue&type=style&index=0&id=b930e41a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports